<template>
  <div id="order" class="order">
    <h2>Созвонимся или спишемся?</h2>
    <div class="order__subtitle">
      Давайте обсудим все детали?<br>
      Просто заполните форму обратного звонка ниже, а мы Вам тут же перезвоним.<br>
      Это займёт всего <span>{{ timer }} {{ labelSeconds }}</span><br>
    </div>
    <div class="order__content">
      <div class="order__form">
        <div class="order__form-item">
          <label for="form-name" class="order__form-label">Ваше имя</label>
          <input
              ref="inputName"
              v-model="formData.name"
              id="form-name"
              class="order__form-input order__form-input--name red-input"
              type="text"
              autocomplete="given-name"
              placeholder="например, Максим"
              maxlength="39"
              @focus="startTimer"
          >
        </div>
        <div class="order__form-item">
          <label for="form-phone" class="order__form-label">Ваш телефон</label>
          <input
              v-model="formData.phone"
              id="form-phone"
              class="order__form-input order__form-input--phone red-input"
              type="tel"
              autocomplete="tel"
              inputmode="tel"
              ref="inputPhone"
              placeholder="напр, +382 (68) 454-710"
              @focus="startTimer"
          >
        </div>
        <div class="order__form-item order__privacy">
          Мы заботимся о приватности ваших данных и гарантируем, что
          имя и телефонный номер не будут переданы третьим лицам.
        </div>
        <div v-if="status" class="order__form-item order__status-container">
                    <span v-if="status === 'success'">
                        Мы получили вашу заявку и совсем скоро вам перезвоним. Ждите звонка!
                    </span>
          <span v-if="status === 'error'">
                        Упс, что-то сломалось :( <br />
                        Пока мы ремонтируем, вы можете позвонить<br>
                        нам по номеру <a href="tel:+38268454710"><strong>+382 68 454 710</strong></a>,<br>
                        написать мне на почту <a href="mailto:clients@wd-cleaning.me?subject=Вопрос по клинингу">clients@wd-cleaning.me</a><br>
                        или написать нам сообщение в социальных сетях.<br>
                        Извините за неудобство...
                    </span>
          <span v-if="status === 'validation'">
                        Пожалуйста, заполните номер телефона
                    </span>
          <div
              class="order__status-close"
              @click="status = ''"
          >✕
          </div>
        </div>
        <div class="order__form-item order__submit-container">
          <button
              class="red-button order__submit-btn"
              type="button"
              :disabled="buttonDisabled"
              :title="buttonTitle"
              @click="submit"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <div class="order__info">
        <div class="order__phone-description">
          Если вам удобно, вы можете самостоятельно позвонить по указанным ниже
          номерам телефонов
        </div>
        <div class="order__phone-container">
          <a href="tel:+38268454710" class="order__phone">
            <span>+382 (68) 454-710</span>
          </a>
        </div>
        <div class="order__social-description">
          ...или написать нам в социальных сетях
        </div>
        <div class="order__social-networks">
          <a href="https://www.instagram.com/wd.cleaning/" target="_blank" class="order__social-item">
            <div class="order__social-logo">
              <img src="../assets/svg/social-networks/instagram.svg" alt="Мы в Instagram">
            </div>
            <div class="order__social-title">Instagram</div>
          </a>
          <a
              :href="activeTgLink"
              target="_blank"
              class="order__social-item"
              @click="onTgLinkClick"
          >
            <div class="order__social-logo">
              <img src="../assets/svg/social-networks/telegram.svg" alt="Мы в Telegram">
            </div>
            <div class="order__social-title">Telegram</div>
          </a>
        </div>
        <div class="order__email-description">
          ...или отправить письмо email
        </div>
        <a href="mailto:clients@wd-cleaning.me" class="order__email-address">
          <span>clients@wd-cleaning.me</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'order',
  data() {
    return {
      formData: {
        name: '',
        phone: ''
      },
      imask: {
        mask: [
          { mask: '{+382} (00) 000 000' },
          { mask: '{068} (000) 000' },
          { mask: '{68} (000) 000' }
        ]
      },
      status: '',
      buttonText: 'Готово. Позвоните мне!',
      buttonDisabled: false,
      timer: 30,
      interval: null,
      tgLinkClicked: false,
      activeTgLink: '',
      defaultTgLink: 'https://t.me/wd_cleaning'
    };
  },
  computed: {
    labelSeconds() {
      if (this.timer === 1 || this.timer === 21) {
        return 'секунду';
      } else if (this.timer >= 2 && this.timer <= 4 || this.timer >= 22 && this.timer <= 24) {
        return 'секунды';
      } else if (this.timer >= 5 && this.timer <= 20 || this.timer >= 25 && this.timer <= 30) {
        return 'секунд';
      }
      return '';
    },
    buttonTitle() {
      return this.buttonDisabled
          ? 'Вы превысили максимальное количество запросов на обратный звонок'
          : 'Обычно мы отвечаем в течение 5 минут. Вам не придётся долго ждать.';
    },
    formIsValid() {
      return !!(this.formData.phone && this.formData.phone.length >= 5);
    }
  },
  mounted() {
    this.checkLimit();
    this.activeTgLink = this.getTelegramDeepLink();

    // workaround for iPhone autocomplete
    setInterval(() => {
      if (!this.$refs.inputName || !this.$refs.inputPhone) {
        return;
      }
      const nameValue = this.$refs.inputName.value;
      const phoneValue = this.$refs.inputPhone.value;
      if (nameValue !== '' && this.formData.name !== nameValue) {
        this.formData.name = nameValue;
      }
      if (phoneValue !== '' && this.formData.phone !== phoneValue) {
        this.formData.phone = phoneValue;
      }
    }, 50);
  },
  methods: {
    onTgLinkClick() {
      setTimeout(() => {
        this.activeTgLink = this.defaultTgLink;
      }, 100);
    },
    getTelegramDeepLink() {
      const userAgent = navigator.userAgent || navigator.platform || navigator.vendor;

      if (/android/i.test(userAgent)) {
        return 'intent://resolve?domain=wd_cleaning#Intent;package=org.telegram.messenger;scheme=tg;end';
      }

      if (/Mac|iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'tg://resolve?domain=wd_cleaning';
      }

      return this.defaultTgLink;
    },
    startTimer() {
      if (this.interval) return;

      this.interval = setInterval(() => {
        this.timer -= 1;
        if (this.timer === 0) {
          clearInterval(this.interval);
          this.timer = 30;
        }
      }, 1000);
    },
    checkLimit() {
      if (this.getCurrentCount() > 50) {
        this.buttonDisabled = true;
        this.buttonText = 'Запрещено';
        return true;
      }

      return false;
    },
    getCurrentCount() {
      if (localStorage) {
        const submitCount = localStorage.getItem('submitCount');
        const parsed = Number.parseInt(submitCount);
        if (!isNaN(parsed)) return parsed;
      }
      return 0;
    },
    async submit() {
      if (!this.formIsValid) {
        this.status = 'validation';
        return;
      }
      this.buttonText = 'Секундочку...';
      this.buttonDisabled = true;
      if (this.checkLimit()) {
        return;
      }

      if (localStorage) {
        let value = this.getCurrentCount();
        value += 1;
        localStorage.setItem('submitCount', value.toString());
      }

      try {
        await axios.post(
        'https://eo3luufefbai6ou.m.pipedream.net',
        {
          name: this.formData.name,
          phone: this.formData.phone
        })
        this.formData.name = '';
        this.formData.phone = '';
        this.status = 'success';

        setTimeout(() => {
          this.buttonDisabled = false;
          this.buttonText = 'Готово. Позвоните мне!';
        }, 1000);
      } catch {
        this.status = 'error';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/vars';

.order {
  border-top: 1px solid $color-border;

  &__subtitle {
    padding: 0 40px;
    text-align: center;
    line-height: 24px;
    margin-top: -32px;

    span {
      font-weight: 900;
      display: inline-block;
      width: 116px;
      background-color: $color-primary;
      color: white;
    }
  }

  &__content {
    display: flex;
    margin: 40px auto;
    max-width: 1440px;
  }

  &__form,
  &__info {
    padding: 0 80px;
  }

  &__form {
    border-right: 3px solid $color-border;
  }

  &__form {
    flex: 1;
  }

  &__form-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 36px;
  }

  &__form-label {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  &__status-container {
    text-align: center;
    position: relative;
  }

  &__status-close {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 16px;
    color: #aaa;
    font-weight: 900;
    cursor: pointer;

    &:hover {
      color: $color-text;
    }
  }

  &__privacy {
    margin-top: -12px;
    font-size: 12px;
    color: $color-text;
  }

  &__form-input {
    padding-left: 40px;

    &:focus {
      border-bottom: 3px solid $color-primary;
    }

    &--name {
      background: url('../assets/svg/person.svg') no-repeat left center;
      background-size: 28px;
    }

    &--phone {
      background: url('../assets/svg/phone.svg') no-repeat left center;
      background-size: 28px;
    }
  }

  &__status-container {
    padding: 16px 0;
    background: #d9ffd9;
    border-radius: 4px;
  }

  &__submit-container {
    align-items: center;
  }

  &__submit-btn {
    width: max-content;
    height: 64px;
    border-radius: 37px;
    padding: 20px 32px;
    font-family: $font-primary;
    font-weight: 900;
    text-transform: uppercase;
  }

  &__info {
    flex: 1;
  }

  &__phone-container {
    padding-bottom: 20px;
  }

  &__phone {
    display: inline-block;
    color: #000;
    font-size: 32px;
    font-weight: 400;
    position: relative;

    &:hover {
      &:after {
        transform: scale(1.2);
      }
    }

    &:after {
      content: 'клик';
      padding: 0 2px;
      transition: transform 50ms ease-out;
      background: $color-primary;
      color: white;
      font-size: 11px;
      position: absolute;
      right: -32px;
      top: -4px;
    }
  }

  &__phone-description {
    font-size: 18px;
    margin-bottom: 18px;
  }

  &__social-description {
    font-size: 18px;
    border-top: 3px solid $color-border;
    padding-top: 20px;
  }

  &__social-networks {
    display: flex;
    margin-top: 20px;
    padding-bottom: 20px;
    border-bottom: 3px solid $color-border;
  }

  &__social-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 32px;
    cursor: pointer;

    &:hover .order__social-title {
      color: $color-primary;
    }
  }

  &__social-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
    fill: $color-primary;
  }

  &__social-title {
    color: black;
    font-weight: 400;
    font-size: 14px;
    padding-top: 12px;
    user-select: none;
  }

  &__email-description {
    padding-top: 20px;
    font-size: 18px;
    margin-bottom: 18px;
  }

  &__email-address {
    display: block;
    font-size: 20px;
    font-weight: 400;
    color: $color-primary;
  }

  &__organization-name {
    display: inline-block;
    margin: 24px 0 18px;
    padding-top: 10px;
    border-top: 3px solid $color-border;
  }

  &__vk-widget {
    margin-top: 40px;
  }
}

/* Large desktops and laptops */
@media (min-width: 1200px) {

}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {

}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 1023px) {
  .order {
    &__form,
    &__info {
      padding: 0 80px;
    }
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .order {
    &__form-item {
      margin-bottom: 20px;
    }

    &__subtitle {
      margin-top: 0;
    }

    &__form,
    &__info {
      padding: 0 20px;
    }

  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 1023px) {
  .order {
    &__content {
      flex-direction: column;
    }

    &__form {
      border-right: 0;
    }

    &__phone {
      font-size: 24px;
    }
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {

}

/* Iphone 5 */
@media (max-width: 320px) {

}
</style>
